
export default {
  auth: false,
  created() {
    this.$router.push(this.localeRoute('/home'))
  },
}
